angular.module('picmonic-common').controller('WebinarsController', [
  '$rootScope',
  '$scope',
  '$controller',
  '$filter',
  '$modal',
  '$state',
  '$timeout',
  '$anchorScroll',
  'UserService',
  'WebinarResource',
  'WebinarsService',
  function (
    $rootScope,
    $scope,
    $controller,
    $filter,
    $modal,
    $state,
    $timeout,
    $anchorScroll,
    UserService,
    WebinarResource,
    WebinarsService
  ) {
    $scope.loading = true;
    $scope.recordedLoading = true;
    $scope.liveLimit = 2;
    $scope.recordedLimit = null;
    $scope.base_asset_url = $rootScope.base_asset_url;
    $scope.$state = $state;
    $scope.WebinarsService = WebinarsService;
    $scope.UserService = UserService;
    $scope.on_demand_bg_image =
      'url(' + $rootScope.base_asset_url + '/assets/img/events/on-demand-webinar-block-bg-v3.jpg' + ')';

    WebinarResource.query(
      function (data) {
        $scope.webinars = WebinarsService.process(data);
        $scope.loading = false;
        if ($state.params.prerecorded) {
          $timeout(function () {
            $anchorScroll.yOffset = 64;
            $anchorScroll('prerecorded');
          }, 0);
        }
      },
      function () {
        $scope.loading = false;
      }
    );

    var recordedParams = { webinar_id: 'recorded' };
    if ($state.params.market_id) {
      recordedParams.market_id = $state.params.market_id;
      UserService.setMarketCookies(recordedParams.market_id);
    } else if (UserService.user.lead) {
      recordedParams.market_id = UserService.user.lead;
    }

    if ($state.current.name === 'app.resources.tab') {
      $scope.recorded = $filter('filter')(
        $scope.$parent.$parent.$parent.resources.resources,
        {
          resource_category_id: 3,
          resource_tab_id: $scope.$parent.$parent.$parent.selectedTab.resource_tab_id,
        },
        true
      );
      $scope.recordedLoading = false;
    } else {
      $scope.recorded = WebinarResource.query(recordedParams);
      $scope.recorded.$promise.finally(function () {
        $scope.recordedLoading = false;

        if ($state.params.recorded_id) {
          angular.forEach($scope.recorded, function (value) {
            if (parseInt(value.resource_id, 10) === parseInt($state.params.recorded_id, 10)) {
              WebinarsService.playRecorded(value);
            }
          });
        }
      });
    }

    $scope.minutes = function () {
      var minutes = Math.floor($scope.diff / 60) % 60;
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      return minutes;
    };

    $scope.seconds = function () {
      var seconds = $scope.diff % 60;
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return seconds;
    };

    $scope.onDemandRegisterButtonClicked = function () {
      $rootScope.$broadcast('ondemand.toggle', {});
    };

    $rootScope.$on('ondemand.diff', function (evt, data) {
      $scope.diff = data.diff;
    });
  },
]);
